import OrdersTable from "../orders/OrdersTable";

export default function RecentOrders({ orders, onOpenOrder }) {
  return <OrdersTable orders={orders} onOpenOrder={onOpenOrder} />;
}